<template>
  <div class="this-profile page">
    <h1 class="title page-title">
      {{ $t('profile.title') }}
    </h1>

    <div class="imgs panda flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img src="../assets/img/portrait.jpg" alt="portrait">
        </div>
        <div class="flip-card-back">
          <img src="../assets/img/full_working.svg" alt="panda qui travaille">
        </div>
      </div>
    </div>

    <div class="profile-content">
      <h2>{{ $t('profile.me.title') }}</h2>

      <div class="paragraph">
        <p>{{ $t('profile.me.body') }}</p>

        <p>{{ $t('profile.me.body2') }}</p>
      </div>

      <h2>{{ $t('profile.expertise.title') }}</h2>

      <div class="paragraph">
        <p>{{ $t('profile.expertise.body') }}</p>

        <p>{{ $t('profile.expertise.body2') }}</p>

        <p>{{ $t('profile.expertise.body3') }}</p>
      </div>

      <h2>{{ $t('profile.trust.title') }}</h2>

      <div class="paragraph">
        <p>{{ $t('profile.trust.body') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Profile',
        components: {
        },
        data: () => {
            return {
                langs: [{label: 'fr'}, {label: 'en'}],
            }
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';

  .this-profile {
    background-color: $mainColor;
    display: grid;

    h1 {
      text-align: center;
    }

    .panda.flip-card {
      /* The flip card container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
      background-color: transparent;
      width: 450px;
      height: 600px;
      perspective: 1000px; /* Remove this if you don't want the 3D effect */
      border: 3px solid $secondaryColor;
      place-self: center;
      max-width: 450px;

    }
    /* This container is needed to position the front and back side */
    .flip-card-inner {
      position: relative;
      width: 100%;
      height: 100%;
      text-align: center;
      transition: transform 0.8s;
      transform-style: preserve-3d;
      img {
        width: 100%;
        height: 100%;
      }
    }

    /* Do an horizontal flip when you move the mouse over the flip box container */
    .flip-card:hover .flip-card-inner {
      transform: rotateY(180deg);
    }

    /* Position the front and back side */
    .flip-card-front, .flip-card-back {
      position: absolute;
      width: 100%;
      height: 100%;
      -webkit-backface-visibility: hidden; /* Safari */
      backface-visibility: hidden;
    }

    /* Style the front side (fallback if image is missing) */
    .flip-card-front {
      background-color: white;
      color: black;
    }

    /* Style the back side */
    .flip-card-back {
      background: radial-gradient(ellipse at center, $secondaryColor 0%, $mainColor 100%); /* W3C */
      transform: rotateY(180deg);
    }

    .profile-content {
      h2 {
        color: $secondaryColor;
        font-size: 20px;
        font-weight: 400;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .paragraph p {
        color: $white;
        margin-bottom: 30px;
        margin-top: 20px;
      }
    }
  }

  /* large screen */
  @media (min-width: 1200px) {
    .this-profile {
      grid-template-columns: 450px 1fr;
      grid-template-rows: 90px 1fr;
      grid-gap: 50px;

      h1 {
        grid-area: 1 / 1 / 1 / 3;
      }
    }
  }

  /* small screen */
  @media (min-width: 640px) and (max-width: 1200px){
    .this-profile {
      grid-template-columns: 1fr;
      grid-template-rows: 90px 600px 1fr;
      grid-gap: 50px;
    }
  }

  /* mobile */
  @media (max-width: 640px) {
    .this-profile {
      grid-template-columns: 1fr;
      grid-template-rows: 50px 320px 1fr;
      grid-gap: 10px;

      .panda.flip-card {
        width: 240px;
        height: 320px;
      }
    }
  }
</style>
